// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sponsors: UserTick,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  po: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const purchase: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="purchase Management" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [

    {
      id: 'whole-sale-purchase',
      title: <FormattedMessage id="Whole Sale purchase" />,
      type: 'collapse',
      screen_id: 1,
      icon: icons.purchase,
      children: [
        {
          id: 'whole-sale-purchase-list',
          title: <FormattedMessage id="whole-sale-purchase-list" />,
          type: 'item',
          sub_screen_id: 1,
          url: '/apps/purchase/whole-sale-purchase-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-whole-sale-purchase',
          title: <FormattedMessage id="add-new-whole-sale-purchase" />,
          type: 'item',
          sub_screen_id: 2,
          url: '/apps/purchase/add-new-whole-sale-purchase'
        }
      ]
    },
    {
      id: 'purchase',
      title: <FormattedMessage id="purchase" />,
      type: 'collapse',
      screen_id: 2,
      icon: icons.purchase,
      children: [
        {
          id: 'purchase-list',
          title: <FormattedMessage id="Purchase List" />,
          type: 'item',
          sub_screen_id: 3,
          url: '/apps/purchase/purchase-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-purchase',
          title: <FormattedMessage id="Add Purchase" />,
          type: 'item',
          sub_screen_id: 4,
          url: '/apps/purchase/add-new-purchase'
        },
      ]
    },
    {
      id: 'invoice',
      title: <FormattedMessage id="invoice" />,
      url: '/apps/invoice/dashboard',
      type: 'collapse',
      icon: icons.invoice,
      breadcrumbs: true,
      children: [
        {
          id: 'create',
          title: <FormattedMessage id="create" />,
          type: 'item',
          url: '/apps/invoice/create'
        },
        {
          id: 'details',
          title: <FormattedMessage id="details" />,
          type: 'item',
          url: '/apps/invoice/details/1'
        },
        {
          id: 'list',
          title: <FormattedMessage id="list" />,
          type: 'item',
          url: '/apps/invoice/list'
        },
        {
          id: 'edit',
          title: <FormattedMessage id="edit" />,
          type: 'item',
          url: '/apps/invoice/edit/1'
        }
      ]
    },
    {
      id: 'po',
      title: <FormattedMessage id="Purchase Order" />,
      url: '/apps/po/dashboard',
      type: 'collapse',
      icon: icons.po,
      breadcrumbs: true,
      children: [
        {
          id: 'create',
          title: <FormattedMessage id="create" />,
          type: 'item',
          url: '/apps/po/create'
        },
        {
          id: 'details',
          title: <FormattedMessage id="details" />,
          type: 'item',
          url: '/apps/po/details/1'
        },
        {
          id: 'list',
          title: <FormattedMessage id="list" />,
          type: 'item',
          url: '/apps/po/list'
        },
        {
          id: 'edit',
          title: <FormattedMessage id="edit" />,
          type: 'item',
          url: '/apps/po/edit/1'
        }
      ]
    },
  ]
};

export default purchase;
